export const UnscanRptConstants ={
    GETALL_REQUEST: 'Unscan_GETALL_REQUEST',
    GETALL_SUCCESS: 'Unscan_GETALL_SUCCESS',
    GETALL_FAILURE: 'Unscan_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'Unscan_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'Unscan_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'Unscan_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST'
}